import Vue from 'vue';
import { Store, Module, ActionContext } from 'vuex'
import ListModule from './list-module'
import ListState from './list-state'
import Vuex from 'vuex';
import Ajax from '../../lib/ajax'
Vue.use(Vuex);
import GeneralInventoryReportItem from '@/store/entities/generalInventoryReportItem';
import appconst from '../../lib/appconst';
class SumInfo {
    totalBeginningBalance: number = 0;
    totalBeginningPrice: number = 0;
    totalInboundQty: number = 0;
    totalInboundPrice: number = 0;
    totalOutboundQty: number = 0;
    totalOutboundPrice: number = 0;
    totalEndingBalance: number = 0;
    totalEndingPrice: number = 0;
    totalRows: number = 0;
}
interface GeneralInventoryReportState extends ListState<GeneralInventoryReportItem> {
    sumInfo: SumInfo;
    viewInfo:any;
}

class GeneralInventoryReportModule extends ListModule<GeneralInventoryReportState, any, GeneralInventoryReportItem>{
    state = {
        totalCount: 0,
        currentPage: 1,
        pageSize: 10,
        list: new Array<GeneralInventoryReportItem>(),
        sumInfo: new SumInfo(),
        loading: false,
        
    }
    actions = {
        async getAll(context: ActionContext<GeneralInventoryReportState, any>, payload: any) {
            context.state.loading = true;
            let reponse = await Ajax.get('/api/services/app/Inventory/GeneralInventoryReport', { params: payload.data });
            context.state.loading = false;
            context.state.list = reponse.data.result.items as GeneralInventoryReportItem[];
            context.state.sumInfo = reponse.data.result.sumInfo;
            context.state.totalCount = reponse.data.result.sumInfo.totalRows;
        },
        async exportGeneralInventory(context: ActionContext<GeneralInventoryReportState, any>, payload: any) {
            window.open(`${appconst.remoteServiceBaseUrl}report/ExportGeneralInventoryReport${abp.utils.buildQueryString(Object.keys(payload.data).map((key) => {
                return {
                    name: key,
                    value: payload.data[key]
                }
            }), true)}`, "_blank");
        },

    };
    mutations = {
        setCurrentPage(state: GeneralInventoryReportState, page: number) {
            state.currentPage = page;
        },
        setPageSize(state: GeneralInventoryReportState, pagesize: number) {
            state.pageSize = pagesize;
        },
        refreshListData(state: GeneralInventoryReportState)
        {
            state.list = new Array<GeneralInventoryReportItem>();
            state.sumInfo = new SumInfo();
        },
        view(state:GeneralInventoryReportState,detail:any){
            state.viewInfo=detail;
        }
    }
}
const reportModule = new GeneralInventoryReportModule();
export default reportModule;